

export interface IAppParatemers {
    emailSupport?: boolean;
    smsSupport?: boolean;
    mapSupport?: boolean;

    companyName?: string;
    companyAddress?: string;

    showDeveloperSettings?: boolean;
    showRawApplicationErrors?: boolean;
    testenviromentBackground?: boolean;

    languages?: Array<string>;
    showLanguageSelect?: boolean;

    showAuditSummary?: boolean;
    applicationMenuHref?: string;
}



export interface IAppParatemersDTO {

    // Common with all apps
    sahkoposti_tuki?: boolean;
    sms_tuki?: boolean;
    kartta_tuki?: boolean;
    kehitysvalikko?: boolean;
    nayta_sovellusvirhe_viestit?: boolean;
    yrityksen_nimi?: string;
    yrityksen_osoite?: string;

    kielet?: string;
    nayta_kieli_valikko?: string;
    testiympariston_tausta?: string;
    sovellusvalikko_linkki?: string

    // App spesific
    auditoinnit_sahkoposti_tuki?: boolean;
    auditoinnit_sms_tuki?: boolean;
    auditoinnit_kartta_tuki?: boolean;
    auditoinnit_kehitysvalikko?: boolean;
    auditoinnit_nayta_sovellusvirhe_viestit?: boolean;
    auditoinnit_yritysen_nimi?: string;
    auditoinnit_yrityksen_osoite?: string;
    auditoinnit_kielet?: string;
    auditoinnit_nayta_kieli_valikko?: string;
    auditoinnit_testiympariston_tausta?: boolean;

    auditoinnit_nayta_yhteenveto?: boolean;
    auditoinnit_sovellusvalikko_linkki?: string

};

const ensureBoolean = (uknown: any) => typeof uknown === "boolean" ? uknown : undefined;

/**
 * Mapper primarly uses app spesific parameter and fallbacks to common parameters used in all safety applications.
 */
export const AppParameterMapper = {
    apiToDomain: (api: IAppParatemersDTO): IAppParatemers => ({

        emailSupport: ensureBoolean(api.auditoinnit_sahkoposti_tuki ?? api.sahkoposti_tuki),
        smsSupport: ensureBoolean(api.auditoinnit_sms_tuki ?? api.sms_tuki),
        mapSupport: ensureBoolean(api.auditoinnit_kartta_tuki ?? api.kartta_tuki),

        companyName: api.auditoinnit_yritysen_nimi ?? (api as any).yritysen_nimi ?? api.yrityksen_nimi,
        companyAddress: api.auditoinnit_yrityksen_osoite ?? api.yrityksen_osoite,

        showDeveloperSettings: ensureBoolean(api.auditoinnit_kehitysvalikko ?? api.kehitysvalikko),
        showRawApplicationErrors: ensureBoolean(api.auditoinnit_nayta_sovellusvirhe_viestit ?? api.nayta_sovellusvirhe_viestit),
        testenviromentBackground: ensureBoolean(api.auditoinnit_testiympariston_tausta ?? api.testiympariston_tausta),

        languages: (api.auditoinnit_kielet || api.kielet) ? (api.auditoinnit_kielet ?? api.kielet ?? "").split(",") : undefined,
        showLanguageSelect: ensureBoolean(api.auditoinnit_nayta_kieli_valikko ?? api.nayta_kieli_valikko),

        showAuditSummary: ensureBoolean(api.auditoinnit_nayta_yhteenveto),
        applicationMenuHref: api.auditoinnit_sovellusvalikko_linkki || api.sovellusvalikko_linkki,


    }),
};


